import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { format } from "date-fns";
import { it } from "date-fns/locale";
import { Car, Clock } from "lucide-react";

export default function RecentActivities({ 
  cars, 
  getClienteName, 
  getStatoName, 
  getCampataFullName, 
  isLoading 
}) {
  if (isLoading) {
    return (
      <Card className="glass-effect border-0 shadow-xl">
        <CardHeader className="p-6 border-b border-slate-100">
          <CardTitle className="text-lg font-bold text-slate-800">
            Attività Recenti
          </CardTitle>
        </CardHeader>
        <CardContent className="p-6">
          <div className="space-y-4">
            {Array(5).fill(0).map((_, i) => (
              <div key={i} className="flex items-center gap-4">
                <Skeleton className="w-10 h-10 rounded-full" />
                <div className="flex-1 space-y-2">
                  <Skeleton className="h-4 w-3/4" />
                  <Skeleton className="h-3 w-1/2" />
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="glass-effect border-0 shadow-xl">
      <CardHeader className="p-6 border-b border-slate-100">
        <CardTitle className="text-lg font-bold text-slate-800 flex items-center gap-2">
          <Clock className="w-5 h-5" />
          Attività Recenti
        </CardTitle>
      </CardHeader>
      <CardContent className="p-6">
        <div className="space-y-4">
          {cars.length > 0 ? (
            cars.map((car) => (
              <div key={car.id} className="flex items-center gap-4 p-3 rounded-lg hover:bg-slate-50 transition-colors">
                <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center">
                  <Car className="w-5 h-5 text-white" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-medium text-slate-800">{car.targa}</span>
                    <Badge variant="outline" className="text-xs">
                      {car.marca} {car.modello}
                    </Badge>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-slate-600">
                    <span>{getClienteName(car.cliente_id)}</span>
                    <span>•</span>
                    <span>{getCampataFullName(car.campata_id)}</span>
                  </div>
                </div>
                <div className="text-right">
                  <Badge className="bg-blue-100 text-blue-700">
                    {getStatoName(car.stato_id)}
                  </Badge>
                  <p className="text-xs text-slate-500 mt-1">
                    {car.created_at ? format(new Date(car.created_at), "dd/MM/yyyy HH:mm", { locale: it }) : '-'}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-8">
              <Car className="w-12 h-12 text-slate-300 mx-auto mb-3" />
              <p className="text-slate-500">Nessuna attività recente</p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}